<template>
  <el-tooltip class="item" effect="dark" :content="$t('admin.synchronizeDOS.tooltip')" placement="top-start">
    <el-button
      id="btn-synchronize-dos"
      v-if="$can(permissions.ADMIN_SETTINGS.SYNCHRONIZE_DOS)"
      type="success"
      plain
      @click="handleSynchronizeDos"
      size="mini"
    >
      {{ $t('admin.synchronizeDOS.title') }}
    </el-button>
  </el-tooltip>
</template>

<script>
import { mapActions } from 'vuex';
import { Message } from 'element-ui';
import { ADMIN_SETTINGS_SYNCHRONIZE_DOS } from '@/store/actions';
import constants from '@/utils/constants';

export default {
  name: 'SynchronizeDOS',
  methods: {
    ...mapActions({
      synchronizeDOS: ADMIN_SETTINGS_SYNCHRONIZE_DOS
    }),
    handleSynchronizeDos() {
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.synchronizeDOS().then((response) => {
        this.$message.success(response.message);
      }).finally(() => {
        loading.close();
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#btn-synchronize-dos {
  margin-left: 10px;
}
</style>
